import PropTypes from 'prop-types';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { ReactComponent as ServerErrorIcon } from '../../assets/img/illustrations/server-error.svg';
const ServerError = ({ resetError }) => {
  const { t } = useTranslation(['pages']);

  const handleGoBack = () => {
    if (resetError) {
      resetError();
    }
    window.location.href = '/';
  };

  return (
    <Container className="d-flex align-items-center vh-100">
      <Row className="justify-content-center m-0 w-100">
        <Col xs="12" md="8" lg="6">
          <div style={{ padding: '16px 36px' }}>
            <div
              style={{
                maxWidth: '100%',
                height: 'auto',
                display: 'flex',
                justifyContent: 'center',
                margin: '48px 0',
              }}
            >
              <ServerErrorIcon style={{ width: '100%', height: 'auto' }} />
            </div>
            <h1 className="display-4 text-center text-uppercase mb-3">{t('serverError.title')}</h1>
            <div className="d-flex justify-content-center align-items-center flex-column">
              <p className="text-muted text-center">{t('serverError.message')}</p>
              <div className="d-flex gap-3">
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.reload();
                  }}
                  className="text-uppercase"
                >
                  {t('serverError.reload', 'Reload')}
                </a>
                <span className="text-muted">|</span>
                <a href="/" onClick={handleGoBack} className="text-uppercase">
                  {t('serverError.goBack')}
                </a>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

ServerError.propTypes = {
  resetError: PropTypes.func,
};

export default ServerError;
